export default __webpack_public_path__ + "static/media/photo--lg--food-2.ac54bd71.jpg";